import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { cardHover } from '../../styles/theme';
import { cardDefaultProps, cardShape } from '../../propTypes';
import DeferredCard from '../DeferredCard';
import Caption from './Caption';

const Card = ({
  children, classes, className, classNames, clickthrough, copy, format, formats, image, minimal,
  ready, title, video, isOverlay, colourTheme,
}) => (
  <DeferredCard
    aspect={formats[format]}
    className={cn(className, classes.card, classes[format], minimal && classes.minimal)}
    image={image}
    imageClassName={cn(classes.image, classNames.image)}
    link={clickthrough}
    ready={ready}
    title={title}
    video={video}
  >
    {children
    || (
    <Caption
      classNames={classNames}
      copy={copy}
      title={title}
      isOverlay={isOverlay}
      colourTheme={colourTheme}
    />
    )}
  </DeferredCard>
);

Card.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  minimal: PropTypes.bool,
  ready: PropTypes.bool,
  ...cardShape,
};

Card.defaultProps = {
  children: undefined,
  className: undefined,
  ready: true,
  ...cardDefaultProps,
};

export default injectSheet({
  card: {
    '& a': {
      ...cardHover('$image'),
    },
  },
  image: {
    marginBottom: theme.padding.gutter / 2,
  },
  minimal: {
    marginBottom: theme.padding.gutter,
    '& $image': {
      marginBottom: 0,
    },
  },
})(Card);
